module.exports = __webpack_public_path__ + "img/copy.7f57a791.svg";